const FacultyArchitectureEngineeringSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="none">
      <path
        d="M7.66016 30.43L8.11849 34.5L11.0885 31.6767L16.1668 17.7433C14.9202 17.4317 13.8202 16.8083 12.9218 15.9467L7.66016 30.43ZM23.0785 15.9467C22.1802 16.8083 21.0618 17.4317 19.8335 17.7433L24.9118 31.6767L27.8818 34.5L28.3585 30.43L23.0785 15.9467ZM23.5002 10.6667C23.5002 8.28333 21.9602 6.26667 19.8335 5.49667V1.5H16.1668V5.49667C14.0402 6.26667 12.5002 8.28333 12.5002 10.6667C12.5002 13.71 14.9568 16.1667 18.0002 16.1667C21.0435 16.1667 23.5002 13.71 23.5002 10.6667ZM18.0002 12.5C16.9918 12.5 16.1668 11.675 16.1668 10.6667C16.1668 9.65833 16.9918 8.83333 18.0002 8.83333C19.0085 8.83333 19.8335 9.65833 19.8335 10.6667C19.8335 11.675 19.0085 12.5 18.0002 12.5Z"
        fill="#5D6977"
      />
    </svg>
  );
};

export default FacultyArchitectureEngineeringSvg;
